export default "__VITE_ASSET__0LNKZ1QN__"